import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  createBlogRequest,
  getBlogs,
  removeBlog,
  updateBlogRequest,
} from "../../../../services/api/landing/blogs/blogsApi";

const getLang = () =>
  localStorage.getItem("language") === "ar" ? "ar" : "en";

const toastMessages = {
  add: { en: "Blog created successfully!", ar: "تم إنشاء المدونة بنجاح!" },
  addError: { en: "Failed to create blog.", ar: "فشل في إنشاء المدونة." },
  update: { en: "Blog updated successfully!", ar: "تم تحديث المدونة بنجاح!" },
  updateError: { en: "Failed to update blog.", ar: "فشل في تحديث المدونة." },
  delete: { en: "Blog deleted successfully!", ar: "تم حذف المدونة بنجاح!" },
  deleteError: { en: "Failed to delete blog.", ar: "فشل في حذف المدونة." },
};

export const fetchBlogs = createAsyncThunk(
  "blogs/fetchBlogs",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getBlogs();
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch blogs");
    }
  },
);

export const createBlog = createAsyncThunk(
  "blogs/createBlog",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createBlogRequest(formData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to create blog");
    }
  },
);

export const updateBlog = createAsyncThunk(
  "blogs/updateBlog",
  async ({ blogId, formData }, { rejectWithValue }) => {
    try {
      const response = await updateBlogRequest(blogId, formData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to update blog");
    }
  },
);

export const deleteBlog = createAsyncThunk(
  "blogs/deleteBlog",
  async (blogId, { rejectWithValue }) => {
    try {
      await removeBlog(blogId);
      return blogId;
    } catch (error) {
      return rejectWithValue("Failed to delete blog");
    }
  },
);

const blogSlice = createSlice({
  name: "blogs",
  initialState: {
    blogData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlogs.fulfilled, (state, action) => {
        state.loading = false;
        state.blogData = action.payload;
      })
      .addCase(fetchBlogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createBlog.fulfilled, (state, action) => {
        state.blogData.push(action.payload);
        toast.success(toastMessages.add[getLang()]);
      })
      .addCase(createBlog.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.addError[getLang()]);
      })
      .addCase(updateBlog.fulfilled, (state, action) => {
        const index = state.blogData.findIndex(
          (blog) => blog.id === action.payload.id,
        );
        if (index !== -1) {
          state.blogData[index] = action.payload;
        }
        toast.success(toastMessages.update[getLang()]);
      })
      .addCase(updateBlog.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.updateError[getLang()]);
      })
      .addCase(deleteBlog.fulfilled, (state, action) => {
        state.blogData = state.blogData.filter(
          (blog) => blog.id !== action.payload,
        );
        toast.success(toastMessages.delete[getLang()]);
      })
      .addCase(deleteBlog.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.deleteError[getLang()]);
      });
  },
});

export default blogSlice.reducer;
